import { ERR_INVALID_COOKIE } from './ERR_INVALID_COOKIE.js';
import { getCookieValues } from './getCookieValues.js';
import { getDomainAttribute } from './getDomainAttribute.js';
import { isValidCookie } from './isValidCookie.js';
import { memoizedCookies } from './memoizedCookies.js';

const setCookie = ({
  name,
  value,
  daysToLive,
  isCrossSubdomain = false
}) => {
  const expires = /* @__PURE__ */ new Date();
  if (!isValidCookie(name, value)) {
    throw new Error(`${ERR_INVALID_COOKIE} ${name}=${value}`);
  }
  if (daysToLive) {
    expires.setUTCDate(expires.getUTCDate() + daysToLive);
  } else {
    expires.setUTCMonth(expires.getUTCMonth() + 5);
    expires.setUTCDate(1);
  }
  document.cookie = `${name}=${value}; path=/; expires=${expires.toUTCString()};${getDomainAttribute(
    {
      isCrossSubdomain
    }
  )}`;
  if (memoizedCookies.has(name)) {
    const [value2] = getCookieValues(name);
    if (value2) {
      memoizedCookies.set(name, value2);
    }
  }
};

export { setCookie };
